import * as AppActions from './app';
import * as AuthActions from './auth';
import * as DomainActions from './domain';
import * as DashboardActions from './dashboard';
import * as BusinessActions from './business';
import * as CarriersActions from './carriers';
import * as GreetingActions from './greeting';
import * as BookingSoftwareActions from './bookingSoftware';
import * as VoicemailsActions from './voicemails';
import * as PreferencesActions from './preferences';
import * as BillingActions from './billing';
import * as StaffActions from './staff';
import * as SchedulesActions from './schedules';
import * as ServicesActions from './services';
import * as HelpActions from './help';
import * as ConversationActions from './conversations';
import * as OutreachActions from './outreach';
import * as WebchatActions from './webchat';
import * as formresponseActions from './formresponse';
import * as staffManagementActions from './staffmanagement';
import * as WebBookingActions from './webbooking';
import * as AppointmentReminders from './AppointmentReminder';
import * as StaffMapping from './staffmapping';
import * as Analytics from './analytics';
import * as VoiceAIConfig from './voiceaiconfig';

export default Object.assign(
  {},
  AppActions,
  AuthActions,
  DomainActions,
  DashboardActions,
  BusinessActions,
  CarriersActions,
  GreetingActions,
  BookingSoftwareActions,
  VoicemailsActions,
  PreferencesActions,
  BillingActions,
  StaffActions,
  SchedulesActions,
  ServicesActions,
  HelpActions,
  ConversationActions,
  OutreachActions,
  WebchatActions,
  formresponseActions,
  staffManagementActions,
  WebBookingActions,
  AppointmentReminders,
  StaffMapping,
  Analytics,
  VoiceAIConfig,
);
